import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { hidePreloader } from '../../shared/utils';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-supported.component.html',
  styleUrls: ['./not-supported.component.scss'],
  standalone: false,
})
export class NotSupportedComponent implements AfterViewInit {
  constructor() {}

  ngAfterViewInit() {
    hidePreloader();
  }
}
